import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import { trackProductEvent } from "../../lib/analytics";

export default function ProductAnalyticsListener() {
  const location = useLocation();
  const { user } = useAuth();
  const lastTrackedPathRef = useRef("");

  useEffect(() => {
    const currentPath = `${location.pathname}${location.search || ""}`;
    if (lastTrackedPathRef.current === currentPath) return;

    lastTrackedPathRef.current = currentPath;

    void trackProductEvent(
      "page_view",
      {
        pathname: location.pathname,
        search: location.search || "",
      },
      { user, path: currentPath }
    );
  }, [location.pathname, location.search, user]);

  return null;
}
